export { PlusMaxBadge } from './PlusMaxBadge';
